"use client";

import * as React from "react";
import { Moon, MoonIcon, Sun, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Toggle } from "./toggle";
export function ModeToggle() {
  const {
    setTheme
  } = useTheme();
  return <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-component="ModeToggle" data-sentry-source-file="theme-toggle.tsx">
      <DropdownMenuTrigger asChild data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="theme-toggle.tsx">
        <Button variant="outline" size="icon" data-sentry-element="Button" data-sentry-source-file="theme-toggle.tsx">
          <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" data-sentry-element="Sun" data-sentry-source-file="theme-toggle.tsx" />
          <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" data-sentry-element="Moon" data-sentry-source-file="theme-toggle.tsx" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-sentry-element="DropdownMenuContent" data-sentry-source-file="theme-toggle.tsx">
        <DropdownMenuItem onClick={() => setTheme("light")} data-sentry-element="DropdownMenuItem" data-sentry-source-file="theme-toggle.tsx">
          Light
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("dark")} data-sentry-element="DropdownMenuItem" data-sentry-source-file="theme-toggle.tsx">
          Dark
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("system")} data-sentry-element="DropdownMenuItem" data-sentry-source-file="theme-toggle.tsx">
          System
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>;
}

// create a simple theme toggle for dark and light mode only using toggle component from components/ui/toggle.tsx

export function SimpleThemeToggle() {
  const {
    setTheme,
    theme
  } = useTheme();
  return <Button variant="ghost" className="group/toggle h-8 w-8 px-0" onClick={() => setTheme(theme === "dark" ? "light" : "dark")} data-sentry-element="Button" data-sentry-component="SimpleThemeToggle" data-sentry-source-file="theme-toggle.tsx">
      <SunIcon className="hidden [html.dark_&]:block" data-sentry-element="SunIcon" data-sentry-source-file="theme-toggle.tsx" />
      <MoonIcon className="hidden [html.light_&]:block" data-sentry-element="MoonIcon" data-sentry-source-file="theme-toggle.tsx" />
      <span className="sr-only">Toggle theme</span>
    </Button>;
}